import {
  DomainConfig,
  LocalePrefix,
  createNavigation,
} from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

import {
  getSupportedLocalesArray,
  getDefaultLocale,
} from "@/config/locale.config";
import { SupportedLocale } from "@/enums/locale.enum";

export type LocaleType = SupportedLocale[];
export type DomainType = DomainConfig<LocaleType>;
export type RoutingType = {
  locales: LocaleType;
  defaultLocale: SupportedLocale;
  localeDetection?: boolean;
  localePrefix?: LocalePrefix<LocaleType, "as-needed">;
  domains?: Array<DomainType>;
};

// Base routing configuration using country-specific settings
export const routing: RoutingType = defineRouting({
  locales: getSupportedLocalesArray(),
  defaultLocale: getDefaultLocale(),
  localeDetection: false,
  localePrefix: "as-needed",
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);

// Helper function for locale validation using country-specific locales
export function isValidLocale(locale: string): locale is SupportedLocale {
  const supportedLocales = getSupportedLocalesArray();
  return supportedLocales.includes(locale as SupportedLocale);
}
